// extracted by mini-css-extract-plugin
export default {"wrapper":"CategoryPage_wrapper__3zYmO"};